import { useBreadcrumb } from "@app/shared/components/Breadcrumb/useBreadcrumb";
import { useEffect } from "react";
import { useAgentTranslations } from "./i18n";
import { agentRoutes, isAgentRouteKey } from "../services";

export const useAgentBreadcrumb = (agent_id: string, title?: string) => {
    const setBreadcrumb = useBreadcrumb();
    const { t, keys } = useAgentTranslations();
    const agentName =
        isAgentRouteKey(agent_id)
            ? t(
                  keys[
                      `breadcrumb_${agentRoutes[agent_id]}`
                  ],
              )
            : undefined;

    useEffect(() => {
        setBreadcrumb("agent", t(keys.breadcrumb_home));
        setBreadcrumb(":agent_id", title ?? agentName ?? "");
    }, [setBreadcrumb, t, keys, agentName, title]);
};
